import { create } from 'zustand';

const defaultState: useAlertDialogStoreState = {
    isOpen: false,
    message: '',
};
export const useAlertDialogStore = create<useAlertDialogStoreState & useAlertDialogStoreAction>()((set) => ({
    ...defaultState,
    action: {
        setIsOpen: (isOpen) => set(() => ({ isOpen })),
        setMessage: (message) => set(() => ({ message })),
        openAlertDialog: (message) => set(() => ({ isOpen:true, message })),
    },
}));

export const useOpenAlertDialog = ()=>useAlertDialogStore((state)=>state.action.openAlertDialog)

interface useAlertDialogStoreState {
    isOpen: boolean;
    message: string;
}

interface useAlertDialogStoreAction {
    action: {
        setIsOpen: (isOpen) => void;
        setMessage: (message) => void;
        openAlertDialog: (message) => void;
    };
}
